import React, { useState } from 'react';
import { TextField, Grid, Typography, IconButton, Menu, MenuItem, Dialog, Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { QRCodeCanvas } from 'qrcode.react';

const PathfinderComponent = ({ selectedServer, demo, gameFallback, showFrame }) => {
  const [bankingURL, setBankingURL] = useState("");
  const [lobbyURL, setLobbyURL] = useState("");
  const [helpURL, setHelpURL] = useState("");
  const [qrLink, setQrLink] = useState("");
  const [showQRDialog, setShowQRDialog] = useState(false);
  const [desktopModeToggle, setDesktopModeToggle] = useState(false);
  const [discoToggle, setDiscoToggle] = useState(false);
  const [ingameInterfaceToggle, setIngameInterfaceToggle] = useState(false);
  const [showPlaycheckToggle, setShowPlaycheckToggle] = useState(false);

  // Menu handling for buttons
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentURL, setCurrentURL] = useState('');

  const handleClick = (event, url) => {
    setAnchorEl(event.currentTarget);
    setCurrentURL(url);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openTab = (url) => {
    window.open(url, '_blank');
  };

  // const openFrame = (url = '') => {
  //   showFrame(url);
  // };

  // const handleQRClick = (url) => {
  //   setQrLink(url);
  //   setShowQRDialog(true);
  // };

  const getBankingURLLink = () => (bankingURL ? `&bankingurl=${bankingURL}` : "");
  const getLobbyURLLink = () => (lobbyURL ? `&lobbyurl=${lobbyURL}` : "");
  const getHelpURLLink = () => (helpURL ? `&helpurl=${helpURL}` : "");
  const getDesktopMode = () => (desktopModeToggle ? "&host=desktop" : "");
  const getShowPlaycheck = () => (showPlaycheckToggle ? "&showva=help,playcheck" : "");
  const getDiscoEnabled = () => (discoToggle ? "&apicommsenabled=true" : "");
  const getIngameInterface = () => (ingameInterfaceToggle ? "&interfaceurl=https://quickfireportal.gameassists.co.uk/examples/igi.html" : "");

  // Ensure GameId is coming from selectedServer
  const getGameId = () => selectedServer?.game?.launchID || gameFallback;

  const getLobby = () => {
    const lobby = selectedServer?.lobby?.name || lobbyURL;
    return lobby ? `&lobbyName=${lobby}` : '';
  };

  const getSiteId = (siteName) => {
    const map = {
      njs: 67, mis: 67, pas: 67, ons: 67, cts: 67,
      njp: 71, mip: 71, pap: 71, ctp: 71,
      onp: 96,
    };
    return map[siteName?.toLowerCase()] || '';
  };

  const getShortLanguage = () => '&languageCode=en';

  const siteId = getSiteId(selectedServer?.site?.name);
  const computedEndpoint = 'gamedistribute.com/mobilewebservices_40';
  const token = selectedServer.authToken || '';

  // Generate Real and Demo Pathfinder URLs
  const pathfinderReal = `https://mobile${siteId}.${computedEndpoint}/casino/game/launch?gameName=${getGameId()}&casinoid=${selectedServer?.serverId}${getLobby()}&logintype=VanguardSessionToken&authtoken=${token}${getLobbyURLLink()}${getHelpURLLink()}${getBankingURLLink()}${getDesktopMode()}${getShowPlaycheck()}${getDiscoEnabled()}${getIngameInterface()}`;
  const pathfinderDemo = `https://mobile${siteId}.${computedEndpoint}/casino/game/launch?gameName=${getGameId()}&casinoid=${selectedServer?.serverId}${getLobby()}${getShortLanguage()}&ispracticeplay=true&logintype=VanguardSessionToken&isrgi=true${getLobbyURLLink()}${getHelpURLLink()}${getBankingURLLink()}${getDesktopMode()}${getShowPlaycheck()}${getDiscoEnabled()}${getIngameInterface()}`;

  return (
    <div>
      {/* Toggles */}
      <Grid container alignItems="center" justify="flex-end">
        <Typography variant="body1">
          Generate <b>H5 Mobile</b> launches below. Use the toggles to the right to enable different features.
        </Typography>
        <Button onClick={() => setDesktopModeToggle(!desktopModeToggle)}>
          {desktopModeToggle ? "Disable" : "Enable"} Desktop Mode
        </Button>
        <Button onClick={() => setShowPlaycheckToggle(!showPlaycheckToggle)}>
          {showPlaycheckToggle ? "Disable" : "Enable"} Playcheck & Help
        </Button>
        <Button onClick={() => setDiscoToggle(!discoToggle)}>
          {discoToggle ? "Disable" : "Enable"} DISCO
        </Button>
        <Button onClick={() => setIngameInterfaceToggle(!ingameInterfaceToggle)}>
          {ingameInterfaceToggle ? "Disable" : "Enable"} Ingame Interface
        </Button>
      </Grid>

      {/* Launch Links */}
      <Grid container spacing={3} style={{ marginTop: "16px" }}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            value={pathfinderReal}
            label="Real"
            variant="outlined"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <>
                  <IconButton onClick={(e) => handleClick(e, pathfinderReal)}>
                    <OpenInNewIcon />
                  </IconButton>
                  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                    <MenuItem onClick={() => openTab(currentURL)}>
                      <OpenInNewIcon /> Open in New Tab
                    </MenuItem>
                    {/* <MenuItem onClick={() => openFrame(currentURL)}>
                      <OpenInBrowserIcon /> Open in iFrame
                    </MenuItem> */}
                  </Menu>
                </>
              ),
            }}
            helperText="Launch link for live gameplay"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            value={pathfinderDemo}
            label="Demo"
            variant="outlined"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <>
                  <IconButton onClick={(e) => handleClick(e, pathfinderDemo)}>
                    <OpenInNewIcon />
                  </IconButton>
                  <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                    <MenuItem onClick={() => openTab(currentURL)}>
                      <OpenInNewIcon /> Open in New Tab
                    </MenuItem>
                    {/* <MenuItem onClick={() => openFrame(currentURL)}>
                      <OpenInBrowserIcon /> Open in iFrame
                    </MenuItem> */}
                  </Menu>
                </>
              ),
            }}
            helperText="Launch link for demo gameplay"
          />
        </Grid>
      </Grid>

      {/* Additional URL Fields */}
      <Grid container spacing={3}>
        <Grid item md={4}>
          <TextField
            fullWidth
            value={bankingURL}
            onChange={(e) => setBankingURL(e.target.value)}
            variant="outlined"
            placeholder="Banking URL"
            helperText="URL to go to when navigating to banking from game"
          />
        </Grid>

        <Grid item md={4}>
          <TextField
            fullWidth
            value={lobbyURL}
            onChange={(e) => setLobbyURL(e.target.value)}
            variant="outlined"
            placeholder="Lobby URL"
            helperText="URL to go to when exiting the game"
          />
        </Grid>

        <Grid item md={4}>
          <TextField
            fullWidth
            value={helpURL}
            onChange={(e) => setHelpURL(e.target.value)}
            variant="outlined"
            placeholder="Help URL"
            helperText="URL to go to after selecting the help icon"
          />
        </Grid>
      </Grid>

      {/* QR Code Dialog */}
      <Dialog open={showQRDialog} onClose={() => setShowQRDialog(false)} maxWidth="xs">
        <QRCodeCanvas value={qrLink} size={320} />
      </Dialog>
    </div>
  );
};

export default PathfinderComponent;
